import {useIntl} from 'react-intl';

import {DownloadOutlineIcon} from '../../../icons/download-outline';
import {ActionButton} from '../../../molecules/icon-button';

type Props = {
    fileUrl: string;
    onClick?: () => void;
};

export const DownloadAction = ({fileUrl, onClick: onPress}: Props) => {
    const {formatMessage} = useIntl();
    const downloadButtonLabel = formatMessage({
        id: 'single_image_view.download_tooltip',
        defaultMessage: 'Download',
    });

    return (
        <ActionButton
            className='action-button'
            as='a'
            aria-label={downloadButtonLabel}
            target='_blank'
            rel='noopener noreferrer'
            href={fileUrl}
            tooltip={downloadButtonLabel}
            onPress={onPress}
            download='true'
        >
            <DownloadOutlineIcon size={20} />
        </ActionButton>
    );
};
